import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos'
import React, { useEffect, useState } from 'react'
import {   motion, useMotionValue, useTransform, } from 'framer-motion';
import { useSelector, useDispatch } from 'react-redux'
import {ReactComponent as SadFace} from '../../../assets/new-icons/tradizionaleFace.svg';
import {ReactComponent as RelaxFace} from '../../../assets/new-icons/relaxFace.svg';
import {ReactComponent as HappyFace} from '../../../assets/new-icons/ricaricabileFace.svg';
import {ReactComponent as Check} from '../../../assets/new-icons/check_simple.svg';
import {ReactComponent as Change} from '../../../assets/new-icons/change.svg';
import {ReactComponent as TagliaIcon} from '../../../assets/new-icons/taglia.svg';
import {ReactComponent as Bank} from '../../../assets/new-icons/bank2.svg';
import {ReactComponent as Card} from '../../../assets/new-icons/card.svg';
import ConfermaBTN from '../../ConfermaBTN/ConfermaBTN';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import md5 from 'md5';
import { setIdGruppo } from '../../../features/userSlice';

function Step3({ next }) {
    const dispatch = useDispatch()
    const [startSwipe, setStartSwipe] = useState()
    const navigate = useNavigate()
    const taglia = useSelector((user) => user.user.importo_taglia)
    const defaultMethod = useSelector((user) => user.user.payMethodDefault)
    const iban = useSelector((user) => user.user.datiPagamento.account_iban)
    const token = useSelector((user) => user.user.datiPagamento.token)
    const customerId = useSelector((user) => user.user.info.customer_id)
    const tkn = md5(customerId + 'oYmAIdtki%lu') 

    const opzioneTariffaria = useSelector((user) => user.user.info.opzione_tariffaria)
    const quotaFissaPos = useSelector((user) => user.user.nuoviDatiContratto.qf_positivo)
    const quotaFissaNeg = useSelector((user) => user.user.nuoviDatiContratto.qf_negativo)

    const currentPlan = useSelector((user) => user?.user?.idGruppo)
    const saldoPositivo = useSelector((user) => user.user.nuoviDatiContratto.mono_positivo)
    const saldoNegativo = useSelector((user) => user.user.nuoviDatiContratto.mono_negativo)
    const x = useMotionValue(0)
    const xInput = [0, 100]
    const background = useTransform(
        x,
        xInput,
        [
            "#EBEBEB",
            "#5AD8A6"
        ]
    )
    const backgroundIcon = useTransform(
        x,
        xInput,
        [
            "#B2B3B4",
            "#fff"
        ]
    )
    const opacityOne = useTransform(
        x,
        xInput,
        [
            '1',
            '0'
        ]
    )
    const opacityTwo = useTransform(
        x,
        xInput,
        [
            '0',
            '1'
        ]
    )
    const widthOne = useTransform(
        x,
        xInput,
        [
            '0',
            '30'
        ]
    )

    const color = useTransform(x, xInput, [
        "#EBEBEB",
        "#5AD8A6"
      ]);
    const tickPath = useTransform(x, [10, 100], [0, 1]);
    const crossPathA = useTransform(x, [-10, -55], [0, 1]);
    const crossPathB = useTransform(x, [-50, -100], [0, 1]);

    
    const getPlanName = () => {
        switch (currentPlan) {
            case 1:
                return 'Ricaricabile'
            case 2:
                return 'Relax'

            case 3:
                return 'Tradizionale'
            default:
                break;
        }
    }
    const getPlanFace = () => {
        switch (currentPlan) {
            case 1:
                return <HappyFace />
            case 2:
                return <RelaxFace />

            case 3:
                return <SadFace/>
            default:
                break;
        }
    }
    const handleSave = async (x) => {
       
     
        const urlId = `https://my.revoluce.it/area_utente/gestione/api/faidate/setGruppo.php?customer_id=${customerId}&id_gruppo=2&tkn_pvt=${tkn}`
        const { data } = await axios.get(urlId)
        dispatch(setIdGruppo(2))
        setTimeout(() => {
            navigate('/enrica/nuovo-piano')
        },1000)
       
    }
    return (
        <>
            <p className="main">Conferma il tuo nuovo piano:</p>
            <p className="secondary">Stai passando dal piano {getPlanName()} a Relax</p> 
            <div className={`boxPlan ${currentPlan === 3 ? 'red' : currentPlan === 2 ? 'orange' : 'green'}`}>
                <div className="labelTop">
                    <p className='bold'>Il tuo piano attuale</p>
                    <Check />
                </div>
                <div className="top_container">
                    <div className="icon">
                        {getPlanFace()}
                    </div>
                    <div className="text">
                        <p className='main bold'>
                            {
                                currentPlan === 1 
                                ? 
                                parseFloat(saldoPositivo).toFixed(2).replace(/\./g, ",")
                                : currentPlan === 2 
                                ?
                                parseFloat(saldoNegativo - 0.02).toFixed(2).replace(/\./g, ",")
                                :
                                parseFloat(saldoNegativo).toFixed(2).replace(/\./g, ",")
                            } <span>€/kWh </span>
                            {
                                opzioneTariffaria && opzioneTariffaria === 'D2'
                                ?
                                null
                                :
                                currentPlan === 1 
                                ?
                                <span className='quotaFissa'>+ {parseFloat(quotaFissaPos).toFixed(2).replace(/\./g, ",")}€ al giorno</span>
                                : currentPlan === 2
                                ?
                                <span className='quotaFissa'>+ {parseFloat(quotaFissaNeg - 0.02).toFixed(2).replace(/\./g, ",")}€ al giorno</span>
                                :
                                <span className='quotaFissa'>+ {parseFloat(quotaFissaNeg).toFixed(2).replace(/\./g, ",")}€ al giorno</span>
                            }
                        </p>
                        {opzioneTariffaria && opzioneTariffaria !== 'D2' && opzioneTariffaria !== 'D3' ? (
                            <p className='iva'>IVA da aggiungere</p>
                        ) : null}
                        <p className='secondary bold'>{getPlanName()}</p>
                    </div>
                </div>
            </div>
            <div className="changeIcon">
                <Change />
            </div>
            <div className={`boxPlan new orange`}>
                <div className="labelTop">
                    <p className='bold'>Il tuo nuovo piano</p>
                    <Check />
                </div>
                <div className="top_container">
                    <div className="icon">
                        <RelaxFace className='faceType'/>
                    </div>
                    <div className="text">
                        <p className='main bold'>
                            {
                                parseFloat(saldoNegativo - 0.02).toFixed(2).replace(/\./g, ",")
                 
                            } <span>€/kWh </span>
                            {
                                opzioneTariffaria && opzioneTariffaria === 'D2'
                                ?
                                null
                                :
                                <span className='quotaFissa'>+ {parseFloat(quotaFissaNeg - 0.02).toFixed(2).replace(/\./g, ",")}€ al giorno</span>
                            }
                        </p>
                        {opzioneTariffaria && opzioneTariffaria !== 'D2' && opzioneTariffaria !== 'D3' ? (
                            <p className='iva'>IVA da aggiungere</p>
                        ) : null}
                        <p className='secondary bold'>Relax</p>
                    </div>
                </div>
                
                <div className="param">
                    <div className="icon">
                        <TagliaIcon className='paramIcon'/>
                    </div>
                    <p className="secondary">Taglia</p>
                    <p className="number">
                        {taglia && taglia}
                        <span className="currency">€</span>
                    </p>
                </div>
                <div className="param">
                    {defaultMethod && defaultMethod === 'RID' ? (
                        <>
                            <div className="icon">
                                <Bank className='bankIcon'/>
                            </div>
                            <p className="secondary">SDD</p>
                            <p className="iban">
                            ********* {iban.slice(iban.length - 4)}
                            </p>
                        </>
                    ) : (
                        <>
                            <div className="icon">
                                <Card className='paramIcon'/>
                            </div>
                            <p className="secondary">Token</p>
                            <p className="token">
                                Inserire token
                            </p>
                        </>
                    )}
                </div>
            </div>

            <ConfermaBTN text="Conferma cambio del piano" confermTxt={`Confermi di voler passare da ${getPlanName()} a Relax?`} handleSave={handleSave} />

            {/* Swipe Button */}
            {/* <div className="swipeContainer">
                <motion.div className='swiper' style={{ background, position: 'relative' }}>
                    <motion.div
                        dragElastic={0.7}
                        drag="x"
                        dragConstraints={{left: 0, right: 0 }}
                        style={{ x, position: 'relative', display: 'flex', zIndex: '2'}}
                        onDragStart={(event, info) => setStartSwipe(info.point.x)}
                        onDragEnd={(event, info) => handleSave(info.point.x)}
                    >
                        <motion.div className="iconContainer" style={{background: backgroundIcon}}>
                            <motion.div style={{opacity: opacityOne, width: widthOne}}>
                                <ArrowForwardIos style={{fill: '#fff'}} />
                            </motion.div>
                            <motion.div style={{opacity: opacityTwo}}>
                                <svg className="progress-icon" viewBox="0 0 50 50">
                                    <motion.path
                                        fill="none"
                                        strokeWidth="2"
                                        stroke={color}
                                        style={{ translateX: 5, translateY: 5 }}
                                    />
                                    <motion.path
                                        fill="none"
                                        strokeWidth="2"
                                        stroke={color}
                                        d="M14,26 L 22,33 L 35,16"
                                        strokeDasharray="0 1"
                                        style={{ pathLength: tickPath }}
                                    />
                                    <motion.path
                                        fill="none"
                                        strokeWidth="2"
                                        stroke={color}
                                        d="M17,17 L33,33"
                                        strokeDasharray="0 1"
                                        style={{ pathLength: crossPathA }}
                                    />
                                    <motion.path
                                        fill="none"
                                        strokeWidth="2"
                                        stroke={color}
                                        d="M33,17 L17,33"
                                        strokeDasharray="0 1"
                                        style={{ pathLength: crossPathB }}
                                    />
                                </svg>
                            </motion.div>
                        </motion.div>
                    </motion.div>
                    <motion.div style={{position: 'absolute', left: '0', zIndex: '1', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', paddingLeft: '5%'}}>
                        <p style={{fontSize: '13px'}}>Conferma il cambio del piano</p>
                    </motion.div>
                </motion.div>
            </div> */}
        </>
    )
}

export default Step3
